module.exports = __webpack_public_path__ + "assets/home-slide2.1a7aba6b.jpg";